import React, { useState } from "react";
import { utils } from "../../../utils/utils";
import { Container, Button } from "reactstrap";
import ProgrammingTable from "./ProgrammingTable";
import InformationModal from "../../InformationModal";
import ConfirmationModal from "../../ConfirmationModal";
import ProgrammingDetailsModal from "./ProgrammingDetailsModal";
import { programmingApi } from "../../../services/programmingServices";

const WAITING_FOR_PROGRAMMING_STATUS = 2;
const PROGRAMMING_STATUS = 3;
const WAITING_FOR_PROGRAMMING_TAB = "WAITING_FOR_PROGRAMMING_TAB";

const WaitingForProgramming = ({
  programmingTotal,
  setProgrammingTotal,
  setReloadTabs,
  reloadTabs,
  tabName,
}) => {
  const [programmingStatusId, setProgrammingStatusId] = useState();
  const [programmingSelected, setProgrammingSelected] = useState();
  const [detailModal, setDetailModal] = useState(false);
  const [informationModal, setInformationModal] = useState(
    utils.initInformationModal
  );
  const [confirmationModal, setConfirmationModal] = useState(
    utils.initConfirmationModal
  );

  const columns = [
    {
      accessor: "startProgramming",
      Header: "",
      headerProps: { className: "text-truncate" },
      disableSortBy: true,
      width: 120,
      Cell: (rowData) => {
        return (
          <Button
            className="btn-sm rounded px-1 py-0"
            color={"success"}
            onClick={() => {
              changeProgrammingStatus(rowData.row.original, PROGRAMMING_STATUS);
            }}
          >
            Start Programming
          </Button>
        );
      },
    },
    {
      accessor: "seeJobDetailsButton",
      Header: "Job Details",
      headerProps: { className: "text-truncate" },
      disableSortBy: true,
      width: 125,
      Cell: (rowData) => {
        return (
          <Button
            className="btn-sm rounded px-1 py-0"
            color={"primary"}
            onClick={() => {
              const programming = rowData.row.original;
              setProgrammingSelected(programming);
              setProgrammingStatusId(programming.programmingStatusId);
              setDetailModal(true);
            }}
          >
            See Job Details
          </Button>
        );
      },
    },
  ];

  const onClear = async () => {
    setConfirmationModal(utils.initConfirmationModal);
    setInformationModal(utils.initInformationModal);
    setDetailModal(false);
    setProgrammingSelected();
    setProgrammingStatusId();
  };

  const changeProgrammingStatus = async (programming, programmingStatusId) => {
    try {
      const startProgramming = programmingStatusId === PROGRAMMING_STATUS;
      setConfirmationModal({
        isOpen: true,
        onSubmit: async () => {
          try {
            await programmingApi.updateProgramming(programming.id, {
              ...programming,
              programmingStatusId,
            });
            onClear();
            setInformationModal({
              isOpen: true,
              title: startProgramming
                ? "Start Programming"
                : "Programming Update",
              body: startProgramming
                ? "Programming started successfully."
                : "Programming updated successfully.",
            });
            setReloadTabs([
              WAITING_FOR_PROGRAMMING_TAB,
              utils.programmingTabs[programmingStatusId],
            ]);
          } catch (error) {
            onClear();
            setInformationModal({
              isOpen: true,
              title: "Error",
              body: "There was an error with your request.",
            });
          }
        },
        onClose: () => setConfirmationModal(utils.initConfirmationModal),
        title: startProgramming ? "Start Programming" : "Programming Update",
        body: startProgramming
          ? `
          <div class="text-center">
            Are you sure you are ready to begin programming this job?
          </div>
        `
          : `
        <div class="text-center">
          Do you confirm you want to update the job ${programming.job.jobNumber}?
        </div>
      `,
        confirmColor: "warning",
      });
    } catch (error) {
      setInformationModal({
        isOpen: true,
        title: "Error",
        body: "There was an error with your request.",
      });
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    changeProgrammingStatus(programmingSelected, programmingStatusId);
  };

  return (
    <Container fluid className="px-0">
      <ProgrammingTable
        columns={columns}
        programmingStatusId={WAITING_FOR_PROGRAMMING_STATUS}
        setProgrammingTotal={setProgrammingTotal}
        programmingTotal={programmingTotal}
        reloadTabs={reloadTabs}
        tabName={tabName}
      />
      {informationModal.isOpen ? (
        <InformationModal
          title={informationModal.title}
          body={informationModal.body}
          onClose={() => setInformationModal(utils.initInformationModal)}
        />
      ) : confirmationModal.isOpen ? (
        <ConfirmationModal {...confirmationModal} />
      ) : detailModal ? (
        <ProgrammingDetailsModal
          programming={programmingSelected}
          detailModal={detailModal}
          onSubmit={onSubmit}
          onClear={onClear}
          readOnly={true}
          enableUpdate={true}
          statusId={programmingStatusId}
          setStatusId={setProgrammingStatusId}
        />
      ) : null}
    </Container>
  );
};

export default WaitingForProgramming;
